import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import SheetTitle from '../../../components/SheetTitle';
import { slugify } from '../../../helpers/view';

import c from '../Search.less';

function GenresBlock({ items }) {
  return (
    <div>
      <SheetTitle title="Genres" />
      <ul className={c.seriesList}>
        {
          items.map((item) => (
            <li className={c.tag} key={item.id}>
              <Link to={`/genre/${slugify(item.name, item.id)}`}>{item.name}</Link>
            </li>
          ))
        }
      </ul>
    </div>
  );
}

GenresBlock.propTypes = {
  items: PropTypes.array.isRequired,
};

export default GenresBlock;
